// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__31oIs","actions":"GroupTable_actions__2XAJq","deleteModalFooter":"GroupTable_deleteModalFooter__2lh4D"};